import { useEffect, useState } from "react";
import {
  get_wallet_users,
  post_wallet_verification,
} from "../reduxData/user/userAction";
import { useDispatch } from "react-redux";
import CustomPaymentModel from "./Products/Latest/Hooks/CustomPaymentRequest";
import { formatDollarPrice, formatNoDollarPrice } from "../utils/Price";
import ImagePreviewModal from "../Modals/ImagePreviewModal";
// import CustomPaymentModel from "./Products/Latest/Hooks/CustomPaymentRequest";

const { REACT_APP_IMAGE_URL } = process.env;

const WalletManagement = () => {
  const [user, setUser] = useState([]);
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState("pending");
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [openuser, setopenUser] = useState();
  const [orderId, setOrderId] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  const dispatch = useDispatch();

  // const [id, setId] = useState("");

  useEffect(() => {
    const fetchData = async (
      page = currentPage,
      rows = perPage,
      role = "user"
    ) => {
      try {
        const data = await get_wallet_users(filter);
        console.log("data of user", data);
        setUser(data?.data);
        setTotal(data?.total || 0);
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchData();
  }, [currentPage, perPage, currentPage, filter]);

  const rejectRequest = async (reason) => {
    console.log("Reject reuest", reason);
    const payload = {
      // order_id:openuser?.order_id,
      seller_id: openuser?.seller_id,
      wallet_transaction_id: openuser?.wallet_transaction_id,
      reason,
      transaction_status: "reject",
    };
    const res = await post_wallet_verification(
      payload,
      openuser?.wallet_transaction_id
    );
    if (res) {
      setOpen(false);
      setFilter("reject");
    }
  };
  const approved = async (img) => {
    // console.log("approved payment")
    console.log("user", openuser);
    const payload = {
      //  order_id:openuser?.order_id,
      seller_id: openuser?.seller_id,
      wallet_transaction_id: openuser?.wallet_transaction_id,
      proof_image: img,
      transaction_status: "approved",
    };
    const res = await post_wallet_verification(
      payload,
      openuser?.wallet_transaction_id
    );
    if (res) {
      setOpen(false);
      setFilter("approved");
    }
  };
  return (
    <>
      <div className="container-xxl overflow-x-scroll">
        <h3 class="fw-600 col-md-6 mb-4">Withdraw Requests</h3>

        <ul className="list-inline mb-0 sorting-list mb-3">
          <li className="list-inline-item mb-2 mb-md-0">
            <button
              onClick={() => {
                setFilter("pending");
                setUser([]);
              }}
              className={` text-nowrap text-decoration-none text-capitalize border rounded-pill px-3 py-2 ${
                filter == "pending" ? "active" : ""
              }  `}
            >
              Pending
            </button>
          </li>
          <li className="list-inline-item mb-2 mb-md-0">
            <button
              onClick={() => {
                setFilter("approved");
                setUser([]);
              }}
              className={`text-nowrap text-decoration-none text-capitalize border rounded-pill px-3 py-2 ${
                filter == "approved" ? "active" : ""
              }  `}
            >
              Approved
            </button>
          </li>
          <li className="list-inline-item mb-2 mb-md-0">
            <button
              onClick={() => {
                setFilter("reject");
                setUser([]);
              }}
              className={`text-nowrap text-decoration-none text-capitalize border rounded-pill px-3 py-2 ${
                filter == "reject" ? "active" : ""
              }  `}
            >
              Rejected
            </button>
          </li>
        </ul>
        <table className="table table-hover user-management-table ">
          <thead className="border-gray">
            <th className=" py-3 text-nowrap">Sr.No.</th>
            {/* <th className="text-black bg-black text-white py-3 text-nowrap">Name</th> */}
            <th className=" py-3 text-nowrap ">Reference No.</th>
            <th className=" py-3 text-nowrap ">Email</th>
            <th className="py-3 text-nowrap text-center">Requested Amount</th>
            {filter == "approved" && (
              <th className="py-3 text-nowrap text-success fw-bold">Proff</th>
            )}
            {filter == "reject" && (
              <th className="py-3 text-nowrap text-danger fw-bold">Reason</th>
            )}
            <th className=" py-3 text-nowrap text-center">
              Transaction Status
            </th>
            {/* <th className=" py-3 text-nowrap text-center">Current Balance</th> */}
            {filter == "pending" && (
              <th className="  py-3 text-nowrap">Request</th>
            )}
          </thead>
          <tbody>
            {user?.length > 0 ? (
              user?.map((i, key) => (
                <tr>
                  <td>{key + 1}</td>
                  <td className="text-center">{i?.ref_no || "-"}</td>
                  {/* <td>
                                    {i?.user_name || "-"}
                                </td> */}
                  <td>{i?.seller_email}</td>
                  <td className="text-center">
                    <p>USD {Number(i?.wallet_amount || 0).toFixed(2)}</p>

                    {i?.wallet_amount_in_aed != null && (
                      <p>
                        AED {Number(i.wallet_amount_in_aed || 0).toFixed(2)}
                      </p>
                    )}
                  </td>
                  {filter == "approved" && (
                    <td className="order-product-image text-center">
                      {i?.proof_image ? (
                        <div
                          onClick={(img) => {
                            setPreviewOpen(true);
                            setPreviewImage(i?.proof_image);
                          }}
                        >
                          <img
                            className="img-fluid cursor-pointer"
                            src={`${REACT_APP_IMAGE_URL}${i?.proof_image}`}
                          />
                        </div>
                      ) : (
                        "-"
                      )}
                    </td>
                  )}
                  {filter == "reject" && (
                    <td className=" text-capitalize text-danger">
                      {i?.reason || ""}
                    </td>
                  )}
                  <td className="text-capitalize text-center">
                    {i?.transaction_status || "Pending"}
                  </td>
                  {/* <td className=" fw-bold text-center">
                    {formatDollarPrice(i?.wallet_amount)}
                  </td> */}
                  {filter == "pending" && (
                    <td>
                      <button
                        onClick={() => {
                          setOpen(true);
                          setopenUser(i);
                        }}
                        className=" btn btn-dark  rounded-4 text-white btn-sm px-3"
                      >
                        View Request
                      </button>
                    </td>
                  )}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={6} className="text-center">
                  No Requests!
                </td>{" "}
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <ImagePreviewModal
        open={previewOpen}
        setOpen={setPreviewOpen}
        image={previewImage}
      />

      <CustomPaymentModel
        open={open}
        userDetails={openuser}
        rejectRequwest={rejectRequest}
        approve={approved}
        setOpen={setOpen}
      />
    </>
  );
};
export default WalletManagement;
